module.exports = __webpack_public_path__ + "media/images/icons/omise-31c28957df735b0f1615bd638f4d76a2.svg";